import { C as t } from "./Container-NEmwEwqg.js";
import { p as m, e as n, m as l, d as p, j as a } from "./index-5HZ18Wug.js";
import { styled as s } from "styled-components";
import { I as e, S as c, T as d, V as f, v as y } from "./Spinner-OWhkXHB5.js";
import { E as u } from "./icon-exclamation-mark-7UpkheRz.js";
import { u as $ } from "./useMetaContent-M9Eg3hyC.js";
import { o as g, T as x, c as o } from "./style-V_Aar-SK.js";
import { S as b } from "./Section-4HyI9dhk.js";
import { C as S, R as v, c as T, a as j } from "./Row-y-i4yD9c.js";
import { V as I } from "./Video-AUCpfc6p.js";
import { I as R } from "./Image-g9ZczSQv.js";
import { O as h, T as C } from "./Transition-G3V8HHL8.js";
import { R as E } from "./Resizer-rC_oQBlZ.js";
const O = s.div`
  ${({ $fontFamily: r }) => g(x.bodyS, r)}
  ${m}

  display: flex;
  align-items: center;
  margin: ${n.spacer5} 0;
  background-color: ${o.redAlert};
  color: ${o.white};
`, V = s(e)`
  ${l};
  border: 1px solid ${o.white};
  border-radius: ${p.round};
`, _ = ({ children: r }) => {
  const i = $("font-family");
  return /* @__PURE__ */ a.jsxs(O, { role: "alert", "aria-live": "assertive", $p: "spacer3", $fontFamily: i, children: [
    /* @__PURE__ */ a.jsx(V, { icon: u, $mr: "spacer2" }),
    r
  ] });
}, J = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Col: S,
  Container: t,
  ErrorBoundary: _,
  Icon: e,
  Image: R,
  Overlay: h,
  Resizer: E,
  Row: v,
  Section: b,
  Spinner: c,
  Theme: d,
  Transition: C,
  Video: I,
  VisuallyHidden: f,
  colOffset: T,
  colStyle: j,
  visuallyHidden: y
}, Symbol.toStringTag, { value: "Module" }));
export {
  _ as E,
  J as i
};
